import mjml2html from 'mjml-browser';
import { sanitizeHtml, sanitizeHtmlDocument } from '../utils/sanitizeHtml';

const escapeAttr = (value = '') => String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;');

const blockToMjml = (content) => {
    if (content.type === "image") {
        const { src, width } = content.config;
        const widthAttr = width ? ` width="${escapeAttr(String(width).replace(/px$/, ''))}px"` : '';
        return `<mj-image src="${escapeAttr(src)}" align="${escapeAttr(content.align || 'center')}"${widthAttr} />`;
    } else if (content.type === "text") {
        return `<mj-text>${sanitizeHtml(content.config.text)}</mj-text>`;
    } else if (content.type === "ifelse") {
        return `<mj-raw><!--[#if ${content.config.condition}]--></mj-raw>`
            + content.config.if.content.map(blockToMjml).join('\n')
            + `<mj-raw><!--[#else]--></mj-raw>`
            + content.config.else.content.map(blockToMjml).join('\n')
            + `<mj-raw><!--[/#if]--></mj-raw>`;
    } else if (content.type === "if") {
        const conditionList = content.config.condition ? content.config.condition.split(',') : [];
        const openTags = conditionList.map((condition) => `<!--[#if ${condition}]-->`).join('');
        const closeTags = conditionList.map(() => `<!--[/#if]-->`).join('');
        return `<mj-raw>${openTags}</mj-raw>`
            + content.config.if.content.map(blockToMjml).join('\n')
            + `<mj-raw>${closeTags}</mj-raw>`;
    } else if (content.type === "mjml") {
        return content.config.mjml || '';
    }
    return '';
};

const sectionToMjml = (blocks = []) => {
    return `<mj-section><mj-column>\n${blocks.map(blockToMjml).join('\n')}\n</mj-column></mj-section>`;
};

export const buildMjmlSource = (store) => {
    const state = store.getState();
    const { header, body, footer } = state.design;
    return `<mjml>
  <mj-body width="600px">
    ${sectionToMjml(header)}
    ${sectionToMjml(body)}
    ${sectionToMjml(footer)}
  </mj-body>
</mjml>`;
};

export const renderEmailMjml = async (store) => {
    const { html } = await mjml2html(buildMjmlSource(store));
    return sanitizeHtmlDocument(html);
};
